import { withInstall } from '@element-plus/utils/with-install'
import Switch from './src/switch.vue'

export const ElSwitch = withInstall(Switch)
export default ElSwitch

export * from './src/switch'
